module.exports = __webpack_public_path__ + "img/wb_icon.1f8b60c.png";